'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IoAndroidUpload = function IoAndroidUpload(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm31.2 17c4.1 0.2 7.3 3.5 7.3 7.7 0 4.3-3.5 7.8-7.8 7.8h-20.3c-5.2 0-9.4-4.2-9.4-9.4 0-4.8 3.7-8.8 8.4-9.3 1.9-3.7 5.8-6.3 10.3-6.3 5.8 0 10.4 4.1 11.5 9.5z m-8.9 4.6h5.3l-7.8-7.8-7.9 7.8h5.4v5.9h5v-5.9z' })
        )
    );
};

exports.default = IoAndroidUpload;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/io/android-upload.js
// module id = 2402
// module chunks = 168707334958949